import * as yup from "yup";
import { validationConfirmNewPasswordL, validationEmailField, validationNewPassword, validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  password: validationNewPassword("Password"),
  confirmationPassword: validationConfirmNewPasswordL("Confirmation Password"),
});
